import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { default as MuiDialogContent } from '@material-ui/core/DialogContent';
export var DialogContent = React.forwardRef(function (props, ref) {
    var className = props.className, other = __rest(props, ["className"]);
    var combinedClassName = clsx(className, 'bb-dialog-content');
    return React.createElement(MuiDialogContent, __assign({ tabIndex: -1, className: combinedClassName, ref: ref }, other));
});
export default DialogContent;
//# sourceMappingURL=DialogContent.js.map